import { useStore } from '../../../store/store';
import { NavbarListButton } from '../../Layout/NavbarListButton';
import DuotoneLightIcon from '../DuotoneLightIcon';
import { filterSameColor, iconButtonStyle } from '../../../utils/styles';

/**
 * Couleur d'une box partagée, prise dans la palette du document.
 *
 * Le bouton carré des panneaux de box (cf. Shape.jsx, Line, Image) plutôt
 * qu'une liste déroulante large comme une colonne : dans un panel de 230 px,
 * une carte a huit couleurs à régler — autant de listes empilées repoussaient
 * les bordures et la disposition trois écrans plus bas.
 *
 * L'API reste celle de ColorSelector : on parle en LABELS de palette (la box,
 * elle, stocke une chaîne CSS — cf. useBoxPropsEditor).
 *
 * La couleur choisie teinte l'icône elle-même (`colorInIcon`), comme dans les
 * panneaux Forme / Ombre : sans elle, rien n'indique la valeur en cours.
 *
 * `transparent` reste dans la liste, contrairement au panneau Forme qui
 * l'écarte : ici c'est la valeur « pas de couleur » (fond, teinte du titre),
 * la retirer enlèverait le moyen d'effacer un réglage.
 */
const BoxColorField = ({ label, icon = 'fill-drip', value, disabled, onChange }) => {
  const colors = useStore(({ configuration }) => configuration.colors);

  return (
    <NavbarListButton
      title={label}
      disabled={disabled}
      colorInIcon
      icon={<DuotoneLightIcon name={icon} style={iconButtonStyle()} />}
      onListElementClick={onChange}
      listElements={filterSameColor(colors)}
      selectedElement={colors.find((color) => color.label === value)}
    />
  );
};

export default BoxColorField;
